







































































































































































































































































































































import {
  computed,
  defineComponent,
  nextTick,
  ref,
  toRefs,
  watch,
  vue3Model,
  useRoute,
  PropType,
  onMounted
} from '~/utils/nuxt3-migration'
import CSlider from '~/components/shared/configurable/slider/CSlider.vue'
import { useNamespacedStore } from '~/compositions/store'
import {
  CLASSIFIED_VIEW_NS,
  ClassifiedViewState
} from '~/store/modules/shared/classifieds/view/state'
import { formatNumber } from '~/utils/number'
import { useDeps } from '~/compositions/dependency-container'
import LoanService from '~/services/loan/LoanService'
import LoanCalculatorTimeButton from '~/components/car/classifieds/view/partials/loans/calculator/LoanCalculatorTimeButton.vue'
import { v4 as uuidv4 } from 'uuid'
import LoanPerks from '~/components/car/classifieds/view/partials/loans/perks/LoanPerks.vue'
import CAccordion from '~/components/shared/configurable/accordion/CAccordion.vue'
import LoanCalculatorOpener from '~/components/car/classifieds/view/partials/loans/calculator/LoanCalculatorOpener.vue'
import CImg from '~/components/shared/configurable/image/CImg.vue'
import { defineComponentTranslations } from '~/utils/i18n'
import { useI18n } from '~/compositions/i18n'
import {
  ALPHA_DEFAULT_CONTRIBUTION,
  ALPHA_DEFAULT_FEE,
  ALPHA_DEFAULT_INTEREST,
  ALPHA_MAX_LOAN_AMOUNT,
  ALPHA_MIN_LOAN_AMOUNT,
  ALPHA_SALARIED_INTEREST
} from '~/constants/loan/alpha'

import CPrice from '~/components/shared/configurable/CPrice.vue'
import CInfoModal from '~/components/shared/configurable/info/CInfoModal.vue'
import ColorsExplanation from '~/components/shared/account/overview/colors/ColorsExplanation.vue'
import { debounce } from '~/utils/function'
import { DEBOUNCE_SWIFT } from '~/constants/debounce'
import { LoanMerchantName } from '~/models/loan'
import { useCookies } from '~/compositions/useCookies'
import { useRequestError } from '~/compositions/request-error'
import CConfirmationModal from '~/components/shared/configurable/modal/CConfirmationModal.vue'
import AlphaBankTerms from '~/components/car/classifieds/view/partials/loans/calculator/alpha/AlphaBankTerms.vue'
import { OnlineLoanType } from '~/constants/loan/loans'

export default defineComponent({
  model: vue3Model,
  props: {
    modelValue: { type: Boolean, default: false },
    sessionId: {
      type: String,
      default: () => uuidv4()
    },
    simple: {
      type: Boolean,
      required: false,
      default: false
    },
    collapsible: {
      type: Boolean,
      required: false,
      default: false
    },
    inLanding: {
      type: Boolean,
      required: false,
      default: false
    },
    loanType: {
      type: String as PropType<OnlineLoanType>,
      required: false,
      default: 'alpha-consumer-loan'
    }
  },
  components: {
    AlphaBankTerms,
    CConfirmationModal,
    ColorsExplanation,
    CInfoModal,
    CPrice,
    CImg,
    LoanCalculatorOpener,
    LoanPerks,
    LoanCalculatorTimeButton,
    CSlider,
    CAccordion
  },
  setup(props, { emit }) {
    const { modelValue, inLanding } = toRefs(props)
    const { state } = useNamespacedStore<ClassifiedViewState>(
      CLASSIFIED_VIEW_NS
    )
    const salaried = ref(false)
    const [loanService] = useDeps(LoanService)
    const { t, tc } = useI18n()
    const handleRequestError = useRequestError()
    const internalExpanded = ref(modelValue.value)
    const cookies = useCookies()
    const showCarTermsModal = ref(false)

    const route = useRoute()

    onMounted(() => {
      if (!props.collapsible) {
        loadLoanInfo(true)
      }
    })

    watch(modelValue, (newVal: boolean) => {
      if (loanInstallment.value === null) {
        loadLoanInfo(true)
      }
      internalExpanded.value = newVal
    })

    const classifiedRawPrice = computed(
      () => state.classified?.price.extra.raw_price || 0
    )
    const inClassifiedView = computed(() => {
      return route.value.name?.startsWith('__classifieds_view')
    })

    const hasRangeError = computed(() => {
      return Boolean(
        Number(selectedTimeInput.value) > maxInstallmentMonths.value ||
          Number(selectedTimeInput.value) < minInstallmentMonths.value
      )
    })

    const minLoanAmount = computed<number>(() => ALPHA_MIN_LOAN_AMOUNT)
    const maxLoanAmount = computed<number>(() => ALPHA_MAX_LOAN_AMOUNT)

    const initLoanAmount = computed(() => {
      if (!inLanding.value) {
        if (classifiedRawPrice.value > ALPHA_MAX_LOAN_AMOUNT) {
          return ALPHA_MAX_LOAN_AMOUNT
        } else if (classifiedRawPrice.value < minLoanAmount.value) {
          return minLoanAmount.value
        }
        return classifiedRawPrice.value
      }
      return maxLoanAmount.value
    })

    const loanAmount = ref(initLoanAmount.value)
    const minInstallmentMonths = computed(() => {
      return 6
    })
    const maxInstallmentMonths = computed(() => {
      if (loanAmount.value <= 1000) {
        return 24
      } else if (loanAmount.value <= 3000) {
        return 48
      }
      return 60
    })

    const selectedTimeSlider = ref(maxInstallmentMonths.value)
    const selectedTimeInput = ref(maxInstallmentMonths.value)
    watch(maxInstallmentMonths, (val, oldVal) => {
      if (selectedTimeSlider.value > val) {
        selectedTimeSlider.value = val
      }

      if (selectedTimeInput.value > oldVal && selectedTimeInput.value <= val) {
        // input value had error but now its within max limit so update it to be the same as slider value
        selectedTimeInput.value = selectedTimeSlider.value
      }
    })

    const interestToUse = computed(() =>
      salaried.value ? ALPHA_SALARIED_INTEREST : ALPHA_DEFAULT_INTEREST
    )

    const loanInstallment = ref(null)
    const loadingLoanInfo = ref(false)
    const loadingLoanTarget = ref(false)

    const amountInputRef = ref(null)
    const installmentsInputRef = ref(null)
    const showAmountInput = ref(false)
    const showInstallmentsInput = ref(false)

    function handleTimeButtonClick(time: number) {
      if (selectedTimeSlider.value !== time) {
        selectedTimeSlider.value = time
        loadLoanInfo(false)
      }
    }

    const sliderTooltipFormatter = (v: number) => `${formatNumber(v)} €`
    const monthSliderTooltipFormatter = (v: number) => {
      return tc('months_count', v, { count: v })
    }

    async function loadLoanInfo(ignorePopularity: boolean = false) {
      if (loadingLoanInfo.value || hasRangeError.value) {
        return
      }

      loadingLoanInfo.value = true
      try {
        const { monthlyAmount } = await loanService.getLoanInfo(
          LoanMerchantName.ALPHA,
          loanAmount.value,
          selectedTimeSlider.value,
          props.loanType,
          inClassifiedView.value ? state.classifiedId : undefined,
          salaried.value ? 1 : undefined,
          ignorePopularity
        )
        loanInstallment.value = monthlyAmount
      } catch (error) {
        handleRequestError(error)
        loanInstallment.value = null
      } finally {
        loadingLoanInfo.value = false

        emit('update-loan-amount', loanAmount.value)
      }
    }

    const handleInstallmentsSliderChange = val => {
      selectedTimeInput.value = val
      handleAmountChange()
    }

    const handleAmountChange = debounce(() => {
      loadLoanInfo(false)
    }, DEBOUNCE_SWIFT)

    async function handleGetALoanButtonClick() {
      loadingLoanTarget.value = true
      try {
        const { targetUrl } = await loanService.getLoanTarget(
          LoanMerchantName.ALPHA,
          loanAmount.value,
          selectedTimeSlider.value,
          props.loanType,
          state.classifiedId
        )
        cookies.set(
          'alpharedirect',
          window.location.pathname + window.location.search
        )
        window.location.href = targetUrl
      } catch (e) {
        handleRequestError(e)
      } finally {
        loadingLoanTarget.value = false
      }
    }

    const formattedLoanInstallment = computed(() => {
      if (loanInstallment.value !== null) {
        return loanInstallment.value.toFixed(2)
      }
    })

    const amountInputWidth = computed(() => {
      const letterWidth = 14 // average
      if (loanAmount.value) {
        return `${formatNumber(loanAmount.value).toString().length *
          letterWidth}px`
      }
      return `${letterWidth}px`
    })

    const installmentsInputWidth = computed(() => {
      const letterWidth = 14 // average
      if (selectedTimeInput.value) {
        return `${selectedTimeInput.value.toString().length * letterWidth}px`
      }
      return `${letterWidth}px`
    })

    const onAmountBlur = () => {
      showAmountInput.value = false
      // take the value from the input that was just blured
      const inputValue = Number(amountInputRef.value.value)

      if (inputValue <= minLoanAmount.value) {
        loanAmount.value = minLoanAmount.value
      } else if (inputValue >= maxLoanAmount.value) {
        loanAmount.value = maxLoanAmount.value
      } else {
        loanAmount.value = inputValue
      }

      loadLoanInfo(false)
    }

    const onAmountFocus = () => {
      if (!showAmountInput.value) {
        showAmountInput.value = true
      }
    }

    const onInstallmentsInput = (e: event) => {
      // take the value from the input that was just blured
      const inputValue = Number(e.target.value)
      if (
        inputValue >= minInstallmentMonths.value &&
        inputValue <= maxInstallmentMonths.value
      ) {
        selectedTimeSlider.value = inputValue
      }
      selectedTimeInput.value = inputValue

      loadLoanInfo(false)
    }
    const onInstallmentsBlur = () => {
      showInstallmentsInput.value = false
    }

    const onInstallmentsFocus = () => {
      if (!showInstallmentsInput.value) {
        showInstallmentsInput.value = true
      }
    }

    const onAmountClick = async () => {
      if (showAmountInput.value) {
        return
      }
      showAmountInput.value = true
      await nextTick()
      amountInputRef.value.focus()
      amountInputRef.value.setSelectionRange(-1, -1)
    }

    const onInstallmentsClick = async () => {
      if (showInstallmentsInput.value) {
        return
      }
      showInstallmentsInput.value = true
      await nextTick()
      installmentsInputRef.value.focus()
      installmentsInputRef.value.setSelectionRange(-1, -1)
    }

    return {
      selectedTimeSlider,
      selectedTimeInput,
      handleTimeButtonClick,
      sliderTooltipFormatter,
      monthSliderTooltipFormatter,
      loanAmount,
      classifiedRawPrice,
      maxLoanAmount,
      minLoanAmount,
      formatNumber,
      loanInstallment,
      loadingLoanTarget,
      handleGetALoanButtonClick,
      formattedLoanInstallment,
      amountInputWidth,
      installmentsInputWidth,
      showAmountInput,
      showInstallmentsInput,
      amountInputRef,
      installmentsInputRef,
      onAmountBlur,
      onAmountFocus,
      onInstallmentsBlur,
      onInstallmentsFocus,
      onAmountClick,
      minInstallmentMonths,
      maxInstallmentMonths,
      internalExpanded,
      salaried,
      t,
      ALPHA_SALARIED_INTEREST,
      ALPHA_DEFAULT_INTEREST,
      ALPHA_DEFAULT_FEE,
      ALPHA_DEFAULT_CONTRIBUTION,
      loadLoanInfo,
      interestToUse,
      handleInstallmentsSliderChange,
      handleAmountChange,
      onInstallmentsClick,
      showCarTermsModal,
      hasRangeError,
      loadingLoanInfo,
      onInstallmentsInput
    }
  },
  i18n: defineComponentTranslations({
    alpha_bank_text: {
      en: 'You only need your Alpha Bank e‐Banking credentials.',
      el: 'Χρειάζεσαι μόνο τους κωδικούς e-Banking σου στην Alpha Bank.'
    },
    alpha_bottom_disclaimer: {
      en:
        'You’ll be redirected to a secure Alpha Bank environment to apply for a loan with the details you’ll enter here.',
      el:
        'Θα μεταφερθείς σε ασφαλές περιβάλλον της Alpha Bank για να κάνεις αίτηση για δάνειο με τα στοιχεία που θα επιλέξεις εδώ.'
    },
    alpha_bottom_terms: {
      en: 'Read the terms and conditions.',
      el: 'Δες τους όρους και τις προϋποθέσεις.'
    },
    i_am_salaried_alpha: {
      en: 'I receive my salary/pension at Alpha Bank.',
      el: 'Έχω μισθοδοσία/σύνταξη στην Alpha Bank.'
    },
    alpha_salaried_title: {
      en: 'Info on interest rate',
      el: 'Ενημέρωση για το επιτόκιο'
    },
    alpha_salaried_info: {
      en:
        'The interest rate is {salaried}% if you’re receiving your salary or pension at Alpha Bank. Otherwise it’s {non_salaried}%. It is fixed and includes a {contribution}% Law 128/1975 levy.',
      el:
        'Το επιτόκιο είναι {salaried}% αν έχεις τη μισθοδοσία ή τη σύνταξή σου στην Alpha Bank. Διαφορετικά είναι {non_salaried}%. Είναι σταθερό πλέον εισφοράς Ν.128/75 που σήμερα ανέρχεται σε {contribution}%.'
    },
    installments_range_error: {
      en: 'Choose a term from {min} to {max} months',
      el: 'Επίλεξε διάρκεια από {min} έως {max} μήνες'
    },
    monthly_installment: {
      en: 'Monthly installment',
      el: 'Μηνιαία δόση'
    },
    installment_shorter: {
      en: 'Installment',
      el: 'Μηνιαία δόση'
    },
    alpha_installment_title: {
      en: 'Info on installment',
      el: 'Ενημέρωση για τη δόση'
    },
    alpha_installment_info: {
      en:
        'This is a sample installment and includes: {rate}% + {contribution}% Law 128/1975 levy + {fee}€ application fees divided equally among installments.',
      el:
        'Η δόση είναι ενδεικτική και περιλαμβάνει: Σταθερό επιτόκιο {rate}% + Εισφορά του Ν.128/1975 {contribution}% + Έξοδα αίτησης {fee}€ που μοιράζονται ισόποσα στις δόσεις.'
    }
  })
})
